module.exports = __webpack_public_path__ + "static/frequent-logo-5b268eb788f4f7bf87080df89f12fd84.png";